import useFetchObjects from "../../api/useFetchObjects";

const useSliderBooks = () => {
  return useFetchObjects(["slider-books"], "books/slider/");
};

export default useSliderBooks;
